export const EMPTY_NICHES_MESSAGE = "You must follow a niche to add content to it.";
export const EMPTY_LIST_MESSAGE = "Sorry! We couldn't find any niches to show you.";
